import(/* webpackMode: "eager" */ "/workspace/app/todays-deal/components/Products.jsx")